<!--
 * @Author: aisi
 * @Date: 2020-01-04 09:43:27
 * @LastEditTime : 2020-01-07 17:36:53
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/analyseWord/Index.vue
 -->
<template>
  <div class="word">
    <h1 class="title1 marginb10">一、教学监管</h1>
    <h2 class="title2 marginb10">1. 目标管理</h2>
    <div></div>
    <h1 class="title2 marginb10">2. 达标情况</h1>
    <h2 class="title1 marginb15">二、学情总览</h2>
    <!-- <h2 class="title2 marginb10">1. 全校各科均分分析</h2>
    <CourseAverage></CourseAverage>-->
    <h2 class="title2 marginb15">1. 命题质量分析</h2>
    <Table :columns="testOverallSituationColumns" :data="testOverallSituation.data" stripe></Table>
    <div class="marginb10 descbox">
      <van-row>
        <van-col span="5" class="tit">
          {{
          testOverallSituation.reasonableSubjects.name
          }}
        </van-col>
        <van-col span="19">
          {{
          testOverallSituation.reasonableSubjects.data
          }}
        </van-col>
        <van-col span="5" class="tit">{{ testOverallSituation.difficultySubjects.name }}</van-col>
        <van-col span="19">{{ testOverallSituation.difficultySubjects.data }}</van-col>
      </van-row>
    </div>
    <h2 class="title2 marginb10">2. 等级总体分析</h2>
    <Table
      :columns="rankAnalysisColumns"
      :data="rankAnalysis"
      border
      stripe
      class="marginb15 min_table"
    ></Table>
    <h2 class="title2 marginb10">3. 全A+名单</h2>
    <NameList></NameList>
    <!-- <h2 class="title2 marginb10">4. 5A+名单</h2>
    <NameList></NameList>-->
    <h2 class="title2 marginb10">4. 校区中考科目A+情况对比</h2>
    <!-- <div class="title_desc marginb10">统计中考各级科目，总成绩A+的学生（重要说明，大叔大婶大所多所多所多多）</div> -->
    <Table
      :columns="advancedStudentRankColumns"
      :data="advancedStudentRank"
      show-summary
      class="marginb15"
    ></Table>
    <h2 class="title2 marginb10">5. 校区间关注群体分析</h2>
    <!-- <div class="title_desc marginb10">统计中考各级科目，总成绩A+的学生（重要说明，大叔大婶大所多所多所多多）</div> -->
    <Table
      :columns="focusGroupAnalysisColumns"
      :data="focusGroupAnalysis"
      show-summary
      class="marginb15 min_table"
    ></Table>
    <h2 class="title2 marginb10">历次考试全A+稳定性分析</h2>
    <ChartLine
      :color="color"
      :id="stabilityAnalysis.id"
      :seriesData="stabilityAnalysis.seriesData"
      v-if="stabilityAnalysis.show"
    ></ChartLine>
    <h1 class="title1 marginb10">三、总成绩分析</h1>
    <h2 class="title2">1. 概况</h2>
    <TotalAnalyseSurvey :postList="examinationAnalysis"></TotalAnalyseSurvey>

    <h1 class="title2 marginb10">2. 校区间总成绩平均分对比</h1>
    <Bar
      :color="color"
      :id="averageScoreContrast.id"
      :data="averageScoreContrast.data"
      :seriesData="averageScoreContrast.seriesData"
      :yname="averageScoreContrast.yname"
      :yunit="averageScoreContrast.yunit"
      v-if="averageScoreContrast.show"
    ></Bar>
    <h1 class="title2 marginb10">3. 校区间总成绩分数段对比</h1>
    <Bar
      :color="color"
      :id="fractionalSegment.id"
      :data="fractionalSegment.data"
      :seriesData="fractionalSegment.seriesData"
      :legendData="fractionalSegment.legendData"
      :yname="fractionalSegment.yname"
      :yunit="fractionalSegment.yunit"
      v-if="fractionalSegment.show"
    ></Bar>
    <h1 class="title2 marginb10">3. 校区间总成绩A+人数、占比</h1>
    <Bar
      :color="color"
      :id="rankStudentCount.id"
      :data="rankStudentCount.data"
      :seriesData="rankStudentCount.seriesData"
      :yname="rankStudentCount.yname"
      :yunit="rankStudentCount.yunit"
      v-if="rankStudentCount.show"
    ></Bar>
    <h1 class="title2 marginb10">3. 校区间总成绩竞争力对比图</h1>
    <Scatter
      :color="color"
      :id="competitivePower.id"
      :seriesData="competitivePower.seriesData"
      :yname="competitivePower.yname"
      :xname="competitivePower.xname"
      v-if="competitivePower.show"
    ></Scatter>
    <h1 class="title2 marginb10">3. 历次考试总成绩A+群体稳定性</h1>
    <ChartLine
      :color="color"
      :id="stabilityAnalysis1.id"
      :seriesData="stabilityAnalysis1.seriesData"
      v-if="stabilityAnalysis1.show"
    ></ChartLine>
    <h1 class="title2 marginb10">3. 历次考试总成绩各等级对比</h1>
    <Bar
      :color="color"
      :id="rankStudentCountPrevious.id"
      :ydata="rankStudentCountPrevious.ydata"
      :seriesData="rankStudentCountPrevious.seriesData"
      :yname="rankStudentCountPrevious.yname"
      :legendData="rankStudentCountPrevious.legendData"
      v-if="rankStudentCountPrevious.show"
    ></Bar>
    <h1 class="title2 marginb10">3. 校区间总成绩接近A+人数、占比</h1>
    <div></div>
    <h1 class="title2 marginb10">3. 历次考试总成绩A稳定性</h1>
    <ChartLine
      :color="color"
      :id="stabilityAnalysis2.id"
      :seriesData="stabilityAnalysis2.seriesData"
      v-if="stabilityAnalysis2.show"
    ></ChartLine>
    <h1 class="title2 marginb10">3. 校区间总成绩高端生对比</h1>
    <div></div>
    <h1 class="title2 marginb10">3. 校区间总成绩A+排前1/4 的人数、比例</h1>
    <div></div>
    <h2 class="title2 marginb10">中考科目概况</h2>
    <div></div>
    <h2 class="title2 marginb10">语文分析</h2>
    <div></div>
    <h1 class="title2 marginb10">3. 概况</h1>
    <div></div>
  </div>
</template>
<script>
// import CourseAverage from './studySurvey/CourseAverage'
import { analyseApi } from '../../api/index'
import NameList from './NameList'
import TotalAnalyseSurvey from './components/TotalAnalyseSurvey'
import ChartLine from './components/Line'
import Bar from './components/Bar'
import Scatter from './components/Scatter'
export default {
  components: {
    // CourseAverage,
    NameList,
    TotalAnalyseSurvey,
    ChartLine,
    Bar,
    Scatter
  },
  data() {
    return {
      color: [
        '#37a2da',
        '#32c5e9',
        '#67e0e3',
        '#9fe6b8',
        '#ffdb5c',
        '#ff9f7f',
        '#fb7293',
        '#e062ae',
        '#e690de',
        '#e7bcf3',
        '#9d96f5',
        '#8378ea',
        '#96bfff'
      ],
      examinationid: 337,
      testid: 0,
      schoolid: 43089,
      campusid: 0,
      testOverallSituationColumns: [
        {
          title: '科目',
          key: 'name',
          width: '80'
        },
        {
          title: '难道系数',
          key: 'degreeOfDifficulty',
          width: '100'
        },
        {
          title: '区分度',
          key: 'discrimination',
          width: '80'
        },
        {
          title: '标准差',
          key: 'standardDeviation',
          width: '80'
        },
        {
          title: '信度',
          key: 'reliability',
          width: '80'
        },
        {
          title: '备注',
          key: 'appraise'
        }
      ],
      testOverallSituation: {
        data: [],
        reasonableSubjects: {},
        difficultySubjects: {}
      },
      rankAnalysis: [],
      rankAnalysisColumns: [
        {
          title: '',
          align: 'center',
          key: 'name',
          width: '30'
        }
      ],
      advancedStudentRankColumns: [],
      advancedStudentRank: [],
      focusGroupAnalysisColumns: [],
      focusGroupAnalysis: [],
      examinationAnalysis: [],
      stabilityAnalysis: {
        id: 'stabilityAnalysis',
        data: [],
        seriesData: [],
        show: false
      },
      stabilityAnalysis1: {
        id: 'stabilityAnalysis1',
        data: [],
        seriesData: [],
        show: false
      },
      stabilityAnalysis2: {
        id: 'stabilityAnalysis2',
        data: [],
        seriesData: [],
        show: false
      },
      averageScoreContrast: {
        id: 'averageScoreContrast',
        data: [],
        seriesData: [],
        show: false,
        yname: '得分率',
        yunit: '%'
      },
      fractionalSegment: {
        id: 'fractionalSegment',
        data: [],
        seriesData: [],
        legendData: [],
        show: false,
        yname: '人数',
        yunit: '人'
      },
      rankStudentCount: {
        id: 'rankStudentCount',
        data: [],
        seriesData: [],
        show: false,
        yname: '率',
        yunit: '%'
      },
      competitivePower: {
        id: 'competitivePower',
        seriesData: [],
        show: false,
        yname: '标准差',
        xname: '平均分'
      },
      rankStudentCountPrevious: {
        id: 'rankStudentCountPrevious',
        ydata: [],
        seriesData: [],
        legendData: [],
        show: false,
        yname: '率',
        yunit: '%'
      }
    }
  },
  mounted() {
    this.getTestOverallSituation()
    // this.getRankStudentCountPrevious();
  },
  methods: {
    // 命题质量分析
    getTestOverallSituation() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getTestOverallSituation(params).then(res => {
        if (res.success) {
          this.testOverallSituation.data = res.data.data
          this.testOverallSituation.reasonableSubjects.name =
            res.data.reasonableSubjects.name
          this.testOverallSituation.reasonableSubjects.data = res.data.reasonableSubjects.data.join(
            ','
          )
          this.testOverallSituation.difficultySubjects.name =
            res.data.difficultySubjects.name
          this.testOverallSituation.difficultySubjects.data = res.data.difficultySubjects.data.join(
            ','
          )
        }
        this.getRankAnalysis()
      })
    },
    // 等级总体分析
    getRankAnalysis() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getRankAnalysis(params).then(res => {
        if (res.success) {
          let rankAnalysisColumns = [
            {
              title: '',
              key: 'name',
              align: 'center',
              width: '30'
            }
          ]
          let rankAnalysisData = []
          res.data.forEach((item, k) => {
            if (
              item.name == '语文' ||
              item.name == '数学' ||
              item.name == '英语' ||
              item.name == '物理' ||
              item.name == '化学' ||
              item.name == '政史' ||
              item.name == '中考科目'
            ) {
              let columns = {}
              item.data.forEach((rss, key) => {
                columns = {
                  title: item.name,
                  align: 'center',
                  children: [
                    {
                      title: '人数',
                      key: `studentCount${k}`,
                      align: 'center'
                    },
                    {
                      title: '分数线',
                      key: `scoreLine${k}`,
                      align: 'center'
                    }
                  ]
                }
                if (k == 0) {
                  let obj = {
                    name: rss.rank
                  }
                  obj[`studentCount${k}`] = rss.studentCount
                  obj[`scoreLine${k}`] = rss.scoreLine
                  rankAnalysisData.push(obj)
                } else {
                  rankAnalysisData[key][`studentCount${k}`] = rss.studentCount
                  rankAnalysisData[key][`scoreLine${k}`] = rss.scoreLine
                }
              })
              rankAnalysisColumns.push(columns)
            }
          })
          this.rankAnalysisColumns = rankAnalysisColumns
          this.rankAnalysis = rankAnalysisData
        }
        this.getAdvancedStudentRank()
      })
    },
    // 校区间中考科目A+对比
    getAdvancedStudentRank() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid,
        type: 'summary'
      }
      analyseApi.getAdvancedStudentRank(params).then(res => {
        if (res.success) {
          let advancedStudentRankColumns = [
            {
              title: '校区',
              key: 'name'
            }
          ]
          let advancedStudentRankData = []
          res.data.forEach((item, key) => {
            item.data.forEach((rss, k) => {
              item[`data${k}`] = rss.value
              if (key == 0) {
                let obj = {
                  title: rss.key,
                  key: `data${k}`,
                  width: 70
                }
                advancedStudentRankColumns.push(obj)
              }
            })
            advancedStudentRankData.push(item)
          })
          this.advancedStudentRankColumns = advancedStudentRankColumns
          this.advancedStudentRank = advancedStudentRankData
        }
        this.getFocusGroupAnalysis()
      })
    },
    // 校区间关注群体分析
    getFocusGroupAnalysis() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid,
        type: 'summary'
      }
      analyseApi.getFocusGroupAnalysis(params).then(res => {
        if (res.success) {
          let focusGroupAnalysisColumns = [
            {
              title: '校区',
              key: 'name'
            }
          ]
          let focusGroupAnalysisData = []
          res.data.forEach((item, key) => {
            item.data.forEach((rss, k) => {
              if (rss.key !== '3A+') item[`data${k}`] = rss.value
              if (key == 0) {
                let obj = {
                  title: rss.key,
                  key: `data${k}`,
                  width: 70
                }
                focusGroupAnalysisColumns.push(obj)
              }
            })
            focusGroupAnalysisData.push(item)
          })
          this.focusGroupAnalysisColumns = focusGroupAnalysisColumns
          this.focusGroupAnalysis = focusGroupAnalysisData
        }
        this.getStabilityAnalysis()
      })
    },
    // 历次考试全A+稳定性分析
    getStabilityAnalysis() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid,
        type: 'summary'
      }
      analyseApi.getStabilityAnalysis(params).then(res => {
        if (res.success) {
          let data = [],
            seriesData = [],
            seriesData1 = [],
            seriesData2 = []
          res.data.forEach(item => {
            data.push(item.name)
            seriesData.push(item.data[0]['rate'])
            seriesData1.push(item.data[1]['rate'])
            seriesData2.push(item.data[2]['rate'])
          })
          this.stabilityAnalysis.data = data
          this.stabilityAnalysis.seriesData = seriesData
          this.stabilityAnalysis.show = true
          this.stabilityAnalysis1.data = data
          this.stabilityAnalysis1.seriesData = seriesData1
          this.stabilityAnalysis1.show = true
          this.stabilityAnalysis2.data = data
          this.stabilityAnalysis2.seriesData = seriesData2
          this.stabilityAnalysis2.show = true
        }
        this.getExaminationAnalysis()
      })
    },
    // 总成绩分析概况
    getExaminationAnalysis() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getExaminationAnalysis(params).then(res => {
        if (res.success) {
          let examinationAnalysis = [
            {
              name: '满分',
              data: [
                {
                  tit: '考试满分',
                  value: res.data.examTotalScore
                }
              ]
            },
            {
              name: '平均分',
              data: [
                {
                  tit: '考试平均分',
                  value: res.data.examAverage
                }
              ]
            },
            {
              name: '人数',
              data: [
                {
                  tit: '考试参考人数',
                  value: res.data.examStudentNumber
                }
              ]
            },
            {
              name: '最高分',
              data: [
                {
                  tit: '考试最高分',
                  value: res.data.examMaxScore
                }
              ]
            },
            {
              name: '最低分',
              data: [
                {
                  tit: '考试最低分',
                  value: res.data.examMinScore
                }
              ]
            }
          ]
          this.examinationAnalysis = examinationAnalysis
        }
        this.getAverageScoreContrast()
      })
    },
    // 校区间总成绩平均分对比
    getAverageScoreContrast() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getAverageScoreContrast(params).then(res => {
        if (res.success) {
          let data = [],
            seriesData = []
          res.data.forEach(item => {
            data.push(item.name)
            seriesData.push(item.data[0]['averageRate'])
          })
          this.averageScoreContrast.data = data
          this.averageScoreContrast.seriesData = seriesData
          this.averageScoreContrast.show = true
        }
        this.getFractionalSegment()
      })
    },
    // 校区间总成绩分数段对比
    getFractionalSegment() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getFractionalSegment(params).then(res => {
        if (res.success) {
          let data = [],
            seriesData = [],
            legendData = []
          res.data.forEach((item, key) => {
            let arr = []
            item.data.forEach(rss => {
              if (key == 0) {
                data.push(rss.key)
              }
              arr.push(rss.value)
            })
            legendData.push(item.name)
            seriesData.push(arr)
          })
          this.fractionalSegment.data = data
          this.fractionalSegment.seriesData = seriesData
          this.fractionalSegment.legendData = legendData
          this.fractionalSegment.show = true
        }
        this.getRankStudentCount()
      })
    },
    // 校区间总成绩A+人数、占比
    getRankStudentCount() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getRankStudentCount(params).then(res => {
        if (res.success) {
          let data = [],
            seriesData = []
          res.data.forEach(item => {
            data.push(item.name)
            seriesData.push(item.data[0]['rate'])
          })
          this.rankStudentCount.data = data
          this.rankStudentCount.seriesData = seriesData
          this.rankStudentCount.show = true
        }
        this.getCompetitivePower()
      })
    },
    // 校区间总成绩竞争力对比图
    getCompetitivePower() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getCompetitivePower(params).then(res => {
        if (res.success) {
          let seriesData = []
          res.data.forEach(item => {
            let obj = {
              name: item.name,
              value: [item.average, item.standardDeviation]
            }
            seriesData.push(obj)
          })
          this.competitivePower.seriesData = seriesData
          this.competitivePower.show = true
        }
        this.getRankStudentCountPrevious()
      })
    },
    // 历次考试总成绩各等级对比
    getRankStudentCountPrevious() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid,
        type: 'previous'
      }
      analyseApi.getRankStudentCount(params).then(res => {
        if (res.success) {
          let data = [],
            legendData = [],
            seriesData = []

          res.data.forEach((item, key) => {
            data.push(item.name)
            if (key == 0) {
              item.data.forEach(rss => {
                legendData.push(rss.name)
              })
            }
          })
          legendData.forEach((rs, k) => {
            seriesData.push([])
            res.data.forEach(item => {
              item.data.forEach((rss, i) => {
                if (k == i) {
                  seriesData[k].push(rss.rate)
                }
              })
            })
          })
          this.rankStudentCountPrevious.ydata = data
          this.rankStudentCountPrevious.legendData = legendData
          this.rankStudentCountPrevious.seriesData = seriesData
          this.rankStudentCountPrevious.show = true
        }
        // this.getCompetitivePower();
      })
    },
    // 语文分析概况
    getSingleTestAnalysis() {
      let params = {
        examinationid: this.examinationid,
        testid: this.testid,
        schoolid: this.schoolid,
        campusid: this.campusid
      }
      analyseApi.getExaminationAnalysis(params).then(res => {
        if (res.success) {
          let examinationAnalysis = [
            {
              name: '满分',
              data: [
                {
                  tit: '全卷满分',
                  value: res.data.examTotalScore
                }
              ]
            },
            {
              name: '平均分',
              data: [
                {
                  tit: '全卷平均分',
                  value: res.data.examAverage
                }
              ]
            },
            {
              name: '人数',
              data: [
                {
                  tit: '考试参考人数',
                  value: res.data.examStudentNumber
                }
              ]
            },
            {
              name: '最高分',
              data: [
                {
                  tit: '考试最高分',
                  value: res.data.examMaxScore
                }
              ]
            },
            {
              name: '最低分',
              data: [
                {
                  tit: '考试最低分',
                  value: res.data.examMinScore
                }
              ]
            }
          ]
          this.examinationAnalysis = examinationAnalysis
        }
        this.getAverageScoreContrast()
      })
    },
  }
}
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  background-color: #f8f8f9;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  .word {
    width: 198mm;
    padding: 8mm 6mm;
    background-color: #fff;
    margin: 0 auto;
    .title1 {
      font-size: 17px;
      color: #464c5b;
      font-weight: bold;
    }
    .title2 {
      font-size: 14px;
      color: #fff;
      font-weight: bold;
      background-color: #00c1de;
      display: inline-block;
      padding: 5px 25px 5px 15px;
      border-radius: 0 20px 20px 0;
    }
    .title_desc {
      color: #9ea7b4;
    }
    .marginb15 {
      margin-bottom: 15px;
    }
    .marginb10 {
      margin-bottom: 10px;
    }
    .padding10 {
      padding: 10px;
    }
    .min_table /deep/ .ivu-table-cell {
      padding-left: 2px;
      padding-right: 2px;
    }
    .descbox {
      padding: 20px;
      line-height: 1.75;
      .tit {
        color: #17233d;
        font-weight: bold;
      }
    }
  }
}
</style>
